<template>
	<div class="">
		<div class="fl w-50-l w-100 mv2">
			  <div class="pv2 ph3">
			     <h1 class="f4 fw3 ttu tracked">New American Architecture</h1>
			  </div>
			  <img src="http://www.veevdesign.com/wp-content/uploads/2017/12/PRESS-NEWAMERICANARCHITECTURE-201708-e1512935459506.jpg" class="br3 mw6 center w-100 db" alt="Closeup photo of a tabby cat yawning.">
			  <div class="pa3">
			    <span href="" class="link dim lh-title i">"The best of the best!"</span>
			  </div>
		</div>
		<div class="fl w-50-l w-100 mv2">
			  <div class="pv2 ph3">
			     <h1 class="f4 fw3 ttu tracked">The Architect</h1>
			  </div>
			  <img src="https://static1.squarespace.com/static/545299e5e4b0c69b6556c072/54c54c4ee4b0f7430cbbca81/54c7b9e8e4b0666c7263f9e5/1422375483408/ISA_Press_Architect_Sept2013.jpg" class="br3 mw6 center w-100 db" alt="Closeup photo of a tabby cat yawning.">
			  <div class="pa3">
			    <span href="" class="link dim lh-title i">"Hayman Development is incredible!"</span>
			  </div>
		</div>
		<div class="fl w-50-l w-100 mv2">
			  <div class="pv2 ph3">
			     <h1 class="f4 fw3 ttu tracked">Vogue Living</h1>
			  </div>
			  <img src="https://78.media.tumblr.com/46baf3bfa01f61cbce83aeb1d4cc31ba/tumblr_o9k3betN8B1qeqiguo1_1280.jpg" class="br3 mw6 center w-100 db" alt="Closeup photo of a tabby cat yawning.">
			  <div class="pa3">
			    <span href="" class="link dim lh-title i">"Unprecedented design & work!"</span>
			  </div>
		</div>
		<div class="fl w-50-l w-100 mv2">
			  <div class="pv2 ph3">
			     <h1 class="f4 fw3 ttu tracked">Ocean Homes</h1>
			  </div>
			  <img src="http://troydeaninteriors.com/wp-content/uploads/2014/01/troy2.jpg" class="br3 mw6 center w-100 db" alt="Closeup photo of a tabby cat yawning.">
			  <div class="pa3">
			    <span href="" class="link dim lh-title i">"Professional, unique, timeless!"</span>
			  </div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'Testimonials',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Testimonials.vue